
export const setScheduleFilter = (value: any) => ({
  type: 'SET_SCHEDULE_FILTER',
  payload: value,
})